export default "__VITE_ASSET__Cpp66Jq5__"